import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { AuthKitProvider } from "@workos-inc/authkit-react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "@/components/ui/error-boundary";
import { ErrorFallback } from "@/components/ui/error-fallback";
import { env } from "./env";
import "./index.css";
import { I18nProvider } from "./lib/i18n";
import { convexClient, queryClient } from "./lib/query-client";
import { router } from "./lib/router";
import { initSentry } from "./lib/sentry";
import { AuthProvider } from "./providers/auth-provider";
import { ConvexAuthProvider } from "./providers/convex-auth-provider";

initSentry({ isDev: env.MODE === "development" });

createRoot(document.getElementById("root") as HTMLElement).render(
	<StrictMode>
		<ErrorBoundary FallbackComponent={ErrorFallback}>
			<I18nProvider>
				<AuthKitProvider
					clientId={env.VITE_WORKOS_CLIENT_ID}
					redirectUri={env.VITE_WORKOS_REDIRECT_URI}
					devMode={env.MODE === "development"}
				>
					<ConvexAuthProvider client={convexClient}>
						<QueryClientProvider client={queryClient}>
							<AuthProvider>
								<RouterProvider router={router} />
							</AuthProvider>
						</QueryClientProvider>
					</ConvexAuthProvider>
				</AuthKitProvider>
			</I18nProvider>
		</ErrorBoundary>
	</StrictMode>,
);
